export const elevatorSections = [
  {
    title: 'مشخصات اصلی',
    fields: [
      ['title', 'عنوان'],
      ['elevator_type', 'نوع آسانسور'],
      ['type', 'مدل'],
      ['usage_type', 'کاربری'],
      ['capacity', 'ظرفیت نفر'],
      ['cabin_capacity_kg', 'ظرفیت کابین (کیلوگرم)'],
      ['number_of_floors', 'تعداد طبقات'],
      ['stops_count', 'تعداد توقف'],
      ['operation_type', 'نوع عملکرد'],
      ['elevator_speed_mps', 'سرعت (متر بر ثانیه)'],
    ],
  },
  {
    title: 'موتور و تجهیزات محرکه',
    fields: [
      ['motor_type', 'نوع موتور'],
      ['motor_brand', 'برند موتور'],
      ['motor_power_kw', 'توان موتور (کیلووات)'],
      ['motor_encoder_type', 'انکودر'],
      ['inverter_type', 'نوع اینورتر'],
      ['inverter_power', 'توان اینورتر'],
    ],
  },
  {
    title: 'تابلو فرمان و برق',
    fields: [
      ['control_panel_brand', 'برند تابلو'],
      ['control_panel_serial', 'شماره سریال'],
      ['control_panel_type', 'نوع تابلو'],
      ['control_system_type', 'سیستم کنترل'],
      ['input_voltage', 'برق ورودی'],
      ['landing_call_comm_type', 'ارتباط احضار طبقات'],
    ],
  },
  {
    title: 'درب‌ها',
    fields: [
      ['door_brand', 'برند درب'],
      ['door_count', 'تعداد درب'],
      ['door1_type', 'نوع درب اول'],
      ['door1_voltage', 'ولتاژ درب اول'],
      ['door2_type', 'نوع درب دوم'],
      ['door2_voltage', 'ولتاژ درب دوم'],
      ['door3_type', 'نوع درب سوم'],
      ['door3_voltage', 'ولتاژ درب سوم'],
    ],
  },
  {
    title: 'ایمنی و استاندارد',
    fields: [
      ['weight_sensor', 'سنسور وزن'],
      ['emergency_system_type', 'سیستم اضطراری'],
      ['firefighter_mode', 'حالت آتش‌نشان'],
      ['standard_type', 'استاندارد'],
    ],
  },
];
export const entityLabels = {
  Passenger: 'مسافربر',
  TRACTION: 'کششی',
  HYDRAULIC: 'هیدرولیک',
  RESIDENTIAL: 'مسکونی',
  OFFICE: 'اداری',
  COMMERCIAL: 'تجاری',
  INDUSTRIAL: 'صنعتی',
  SIMPLEX: 'تکی',
  DUPLEX: 'دوتایی',
  GROUP: 'گروهی',
  GEARED: 'گیربکس‌دار',
  GEARLESS: 'بدون گیربکس',
  SWING: 'لولایی',
  SEMI_AUTO: 'نیمه‌اتوماتیک',
  AUTO: 'اتوماتیک',
  OPEN_LOOP: 'حلقه باز',
  CLOSED_LOOP: 'حلقه بسته',
  NONE: 'ندارد',
  EXISTS: 'دارد',
  INACTIVE: 'غیرفعال',
  SINGLE_PHASE: 'تک‌فاز',
  THREE_PHASE: 'سه‌فاز',
  SERIAL: 'سریال',
  PARALLEL: 'موازی',
  OTHER: 'سایر',
  Complex: 'مجتمع',
  Apartment: 'آپارتمان',
  Customer: 'شخص حقیقی',
  Business: 'شرکت',
};
